import { render } from "./PaymentRedirectView.vue?vue&type=template&id=19c3666c"
import script from "./PaymentRedirectView.vue?vue&type=script&lang=js"
export * from "./PaymentRedirectView.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/embody-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__